<icc-list
    [items]="montages"
    itemTemplate="itemImgTitle"
    itemImgHeight="medium"
    (select)="selectMontage($event)"
    [selected]="selectedMontage$ | async"
></icc-list>
